(() => {
    document.addEventListener("DOMContentLoaded", function () {

        const modal_appForms    = $('#modal_appForms').modal('hide');
        const modal_appChannels = $('#modal_appChannels').modal('hide');
        const modal_receive     = $('#modal_receive').modal('hide');
        const modal_validate    = $('#modal_validate').modal('hide');
        const modal_approval    = $('#modal_approval').modal('hide');
        const modal_approve     = $('#modal_approve').modal('hide');
        const modal_allocate    = $('#modal_allocate').modal('hide');
        const modal_approved    = $('#modal_approved').modal('hide');
        const modal_output      = $('#modal_output').modal('hide');

        const flowDiagClick = function (e) {

            switch (e.target.id) {
                case 'appForms_rect':
                    if (modal_appForms !== undefined && modal_appForms !== null) {
                        modal_appForms.modal('show');
                    }
                    break;
                case 'appChannels_rect':
                    if (modal_appChannels !== undefined && modal_appChannels !== null) {
                        modal_appChannels.modal('show');
                    }
                    break;
                case 'receive_rect':
                    if (modal_receive !== undefined && modal_receive !== null) {
                        modal_receive.modal('show');
                    }
                    break;
                case 'validate_rect':
                    if (modal_validate !== undefined && modal_validate !== null) {
                        modal_validate.modal('show');
                    }
                    break;
                case 'approval_rect':
                    if (modal_approval !== undefined && modal_approval !== null) {
                        modal_approval.modal('show');
                    }
                    break;
                case 'approve_rect':
                    if (modal_approve !== undefined && modal_approve !== null) {
                        modal_approve.modal('show');
                    }
                    break;
                case 'allocate_rect':
                    if (modal_allocate !== undefined && modal_allocate !== null) {
                        modal_allocate.modal('show');
                    }
                    break;
                case 'approved_rect':
                    if (modal_approved !== undefined && modal_approved !== null) {
                        modal_approved.modal('show');
                    }
                    break;
                case 'output_rect':
                    if (modal_output !== undefined && modal_output !== null) {
                        modal_output.modal('show');
                    }
                    break;
                default:
                    break;
            }
        }

        const boxes = document.querySelectorAll('.box');
        boxes.forEach(box => {
            box.addEventListener('click', function (e) {
                e.preventDefault();  // Cancel the native event
                e.stopPropagation(); // Don't bubble/capture the event any further
                flowDiagClick(e);
            });
        });
    });
})();




